import { useSelector } from '../index';

export const useCarbonProjectsSelector = () => useSelector(({ projects }) => projects.carbon);

export const useRecommendedProjectsSelector = () =>
  useSelector(({ projects }) => projects.recommended);

export const useForestationProjectsSelector = () =>
  useSelector(({ projects }) => projects.forestation);

export const useSelectedProjectSelector = () => useSelector(({ projects }) => projects.selected);

export const useFilterValuesSelector = () => useSelector(({ projects }) => projects.filterValues);

export const useFilterProjectSelector = () => useSelector(({ projects }) => projects.filters);

export const useSearchLocationSelector = () => useSelector(({ projects }) => projects.search);

export const useSearchSelector = () => useSelector(({ projects }) => projects.searchByNaming);

export const usePaginationSelector = () => useSelector(({ projects }) => projects.pagination);

export const useViewModeSelector = () => useSelector(({ projects }) => projects.viewMode);

export const useFavoriteProjectsSelector = () => useSelector(({ projects }) => projects.favorite);

export const useSelectedRecommendedProjectSelector = () =>
  useSelector(({ projects }) => projects.selectedRecommendedProject);

export const useSelectedRecommendationTypeSelector = () =>
  useSelector(({ projects }) => projects.selectedRecommendationType);

export const useCurrentDataLayerTypeSelector = () =>
  useSelector(({ projects }) => projects.currentDataLayerType);

export const useCurrentSkippedItemsSelector = () =>
  useSelector(({ projects }) => projects.currentSkippedItems);

export const useCurrentGeoRasterDataSelector = () =>
  useSelector(({ projects }) => projects.currentGeoRasterData);

export const useRecommendationPaginationSelector = () =>
  useSelector(({ projects }) => projects.recommendationPagination);

export const useMangroveViewModeSelector = () =>
  useSelector(({ projects }) => projects.mangroveViewMode);
